import React from "react";
import styled, { css } from "styled-components";
import { Link } from "react-router-dom";

import Heading from "core/Heading";

import ArrowLongRight from "core/ReusableIcons/ArrowLongRight";

import breakpoints from "core/breakpoints";
import colors from "core/colors";
import fonts from "core/fonts";

export const AboutHeading = styled(Heading)`
    margin-bottom: 1.5rem; /* 24px */
`;

const detailFormat = css`
    word-break: break-word;
    ${fonts.typeScale[14]};

    margin-bottom: 1.5rem;

    @media (min-width: ${breakpoints.tablet.rem}) {
        margin-bottom: 2rem;
    }
`;

export const Description = styled.div`
    ${detailFormat}
`;

/* for Campaigns: */
export const CampaignsContainer = styled.div`
    ${detailFormat}
    margin-top: 1.5rem; /* 24px */

    /* We're overriding the font.typeScale media properties for line-height */
    line-height: 160%;

    @media (min-width: ${breakpoints.tablet.rem}) {
        line-height: 160%;
    }
`;

export const CampaignLink = styled(Link)`
    color: ${colors.accent.lightMode.persian};
    transition: all 0.2s ease;
    :hover {
        color: ${colors.secondary.cosmic};
    }
`;

export const ArrowContainer = styled.span`
    margin-left: 0.5rem;
    svg {
        vertical-align: middle;
    }
`;

export const CampaignArrow = () => (
    <ArrowContainer>
        <ArrowLongRight size="xs" fillColor={colors.accent.lightMode.persian} />
    </ArrowContainer>
);

export const UploadedDate = styled.div`
    ${({ isIcons }) =>
        isIcons &&
        css`
            /* Mobile only: */
            @media (max-width: ${breakpoints.beforeTablet.rem}) {
                display: none;
            }
        `}
`;
